import { colors } from '@material-ui/core';
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Modal from "react-bootstrap/Modal";
function QuoteCom() {
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));
    const userId = localStorage.getItem('userId');
    const [modalstatus, setModalstatus] = useState(false);
    const [quotelist, setQuotelist] = useState([]);
    const [quote, setQuote] = useState('');
    const [err, setErr] = useState('');
    const [errmsg, setErrmsg] = useState('');
    const [msg, setSmg] = useState('');
    const [operation, setOperation] = useState('')
    const [id, setId] = useState('')
    const showModal = () => {
        setModalstatus(true)
    }
    const get_oermission_data = useSelector((state) => state);
    const extract_permissions = get_oermission_data.login_Permission.permissions ? JSON.parse(get_oermission_data.login_Permission.permissions) : '';
    const hr_permission = get_oermission_data.login_Permission.permissions

    useEffect(() => {
        getQuotes()
    }, [])
    const getQuotes = async () => {
        const response = await fetch(SERVER_URL + `api/quote`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            })
            .then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setQuotelist(data.result)
                }
            });

    }

    const handleClose = () => {
        setModalstatus(false)
        setErr('')
        setQuote('')
        setSmg('')
        setOperation('')
        setId('')
    }
    const handleSubmit = () => {
        setErr('')
        setErrmsg('')
        if (quote == null || quote == '' || quote == undefined) {
            setErr('red')
            setErrmsg('Is Required')
        } else {
            if (id != '') {
                const response = fetch(SERVER_URL + `api/quote/update-quote`,
                    {
                        method: 'PUT',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'authorization': `bearer ${token.value}`
                        },
                        body: JSON.stringify({
                            id: id,
                            description: quote,
                            requestBy: userId
                        }),
                    }).then(res => res.json())
                    .then(data => {
                        if (data.status = true) {
                            setErr('green');
                            setSmg('Quote update successfully')
                            setTimeout(function () {
                                getQuotes()
                                handleClose()
                            }, 1000);
                        }
                    })

            } else {
                const response = fetch(SERVER_URL + `api/quote/add-quote`,
                    {
                        method: 'post',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'authorization': `bearer ${token.value}`
                        },
                        body: JSON.stringify({
                            description: quote,
                            requestBy: userId
                        }),
                    }).then(res => res.json())
                    .then(data => {
                        if (data.status == true) {
                            setErr('green')
                            setSmg('Quote added successfully')
                            setTimeout(function () {
                                getQuotes()
                                handleClose()
                            }, 1000);
                        } else {
                            setErr('red')
                            setSmg('Something went wrong')
                        }
                    })
            }
        }
    }
    const handleQuoteEdit = (id) => {
        setOperation(id)
        getQuoteById(id)
        setModalstatus(true)
    }

    const getQuoteById = async (id) => {
        setId(id)
        const response = await fetch(SERVER_URL + `api/quote/single-quote-details`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    id: id
                }),
            })
            .then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setQuote(data.result.description)
                }
            })
    }
    const handleDelete = (id) => {
        const response = fetch(SERVER_URL + `api/quote/delete-quote`,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    id: id,
                    deleted: 1,
                    requestBy: userId
                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status = true) {
                    getQuotes()
                }
            })
    }
    return (
        <>
            <Modal show={modalstatus} size="md" id="confirm_login">
                <div className="modal-body">
                    <button type="button" className="float-end btn_close" onClick={handleClose}>
                        <i className="icon icon-cross"></i>
                    </button>
                    <div className="dash_white_box_ttl text-center" id="exampleModalLabel">{operation != '' ? 'Edit Quote' : 'Add Quote'}</div>
                    <form>
                        <div className="mb-3">
                            <label className="col-form-label">Quote:<span style={{ color: err }}>{errmsg}</span></label>
                            <textarea value={quote} onChange={(e) => { setQuote(e.target.value) }} className="form-control" id="description"></textarea>
                        </div>
                    </form>
                    <div className="modalfooter">
                        <span style={{ color: err }}>{msg}</span>
                        <button type="button" className="btn_6 float-end ml10" onClick={handleClose}>Cancel</button>
                        <button type="button" onClick={handleSubmit} className="btn_5 float-end">{operation != '' ? 'Edit Quote' : 'Add Quote'}</button>
                    </div>
                </div>
            </Modal>
            <div className="page-header">
                <h1>
                    {
                        (hr_permission?.includes('36') && <button className="btn_5 mt05 float-end" onClick={showModal}>Add Quote</button>)
                    }
                    Quote</h1>
                <ul id="breadcrumbs" className="breadcrumb mb00">
                    <li>
                        <a href="dashboard.html">Dashboard </a>
                    </li>
                    <li className="current">
                        <span>/</span> Quote
                    </li>
                </ul>
            </div>
            <div className="row_bg">
                <div className="mb-4 wp100">
                    <table className="table_style_1">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Quote</th>
                                <th style={{ width: '150' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                quotelist?.map((item, ind) => {
                                    return <tr key={ind + 1}>
                                        <td>
                                            {ind + 1}
                                        </td>
                                        <td>
                                            {item.description ? item.description : ''}
                                        </td>
                                        <td>
                                            {
                                                (hr_permission?.includes('37') && <button className="btn_7 mr03" onClick={(e) => { handleQuoteEdit(item.quoteID) }}>Edit</button>)
                                            }
                                            {
                                                (hr_permission?.includes('37') && <button onClick={(e) => { handleDelete(item.quoteID) }} className="btn_8">Delete</button>)
                                            }
                                        </td>
                                    </tr>
                                })
                            }

                        </tbody>
                    </table>

                </div>
            </div>
        </>

    )
}

export default QuoteCom
